const uk = {
  10000001: 'Святкування другої річниці SuperEx',
  10000002: 'Реєструйтеся, щоб отримати чудові нагороди!',
  10000003: 'Розблокуйте відповідний призовий фонд відповідно до кількості учасників; чим більше учасників, тим більший призовий фонд, до 10,000 USDT',
  10000004: 'Святкування другої річниці SuperEx',
  10000005: 'Виграйте 20 000 USDT у конкурсі ф’ючерсної торгівлі',
  10000006: `Змагання за обсягом торгів, розблокуйте призовий фонд до <span style="color: #ffc72b;">10,000</span> USDT`,
  10000007: 'Чемпіонат з ф\'ючерсів',
  10000008: 'Виграйте 20 000 USDT у конкурсі ф’ючерсної торгівлі',

  10000009: 'Оберіть',
  10000010: 'Загальна кількість токенів',
  10000011: 'Провідник',
  10000012: 'Повернення',
  10000013: 'Далі',
  10000014: 'Попередній',
  10000015: 'Заповніть інформацію',
  10000016: 'Будь ласка, введіть назву токена',
  10000017: 'Введіть повну назву токена.',
  10000018: 'Зрозуміло',
  10000019: 'Будь ласка, введіть назву варіанта торгової пари.',
  10000020: 'Будь ласка, вкажіть циркулюючий запас токена.',
  10000021: 'Готово',
  10000022: 'Після цього ви можете переглянути статистичні дані щодо цієї торгової пари на сторінці Free Market на веб-сайті.',
  10000023: '{currency} на біржі',

  8000067: 'Статистика',
  8000068: 'Назва токена',
  8000069: 'Основний ланцюжок або протокол',
  8000070: 'Адреса контракту або Тікер',
  8000071: 'Ім\'я екземпляра',
  8000072: 'Час створення екземпляра',
  8000073: 'Статус екземпляра',
  8000074: 'Сума комісії ( кумулятивно)/U',
  8000075: 'Сума комісії (за останній тиждень)/U',
  8000076: 'Сума транзакцій (за останній тиждень)/U',
  8000077: 'Кількість транзакцій (за останній тиждень)',
  8000078: 'Створити торгову пару',
  8000079: 'Продовження',
  8000080: 'Занесено до лістингу',
  8000081: 'Буде вилучено з лістингу',
  8000082: 'Вилучено',
  8000083: 'Оберіть токен',
  8000084: 'Сповіщення про лістинг',
  8000085: 'Успішно створено',
  8000086: 'Лістинг в Free Market',
  8000087: 'На SuperEx ви можете легко і безкоштовно розмістити свій список на біржі і мати можливість отримати до 80% дивідендів від торгових зборів.',
  8000088: 'Як це працює?',
  8000089: 'Створення нової торгової пари',
  8000090: 'Я збираюсь лістингувати монету.',
  8000091: 'Створити варіант торгової пари',
  8000092: 'Біржа SuperEx',
  8000093: 'Чому варто обрати нас?',
  8000094: 'Різноманітний вибір',
  8000095: 'Підтримуються багаточисленні ланцюги та протоколи, включаючи BSC ланцюг, ETH ланцюг та SOL ланцюг.',
  8000096: 'Миттєвий лістинг без ручної перевірки, як децентралізований процес, і насолода від зручності торгівлі за допомогою книги ордерів.',
  8000097: 'Підтримка API',
  8000098: 'Ви можете використовувати API інтерфейс для ринкових чи торгових операцій, що зробить ваші дії більш ефективними і автоматизованими.',
  8000099: 'Охоплення та Трафік',
  8000100: 'Розмістивши лістинг в Free Market, насолоджуйтесь величезним трафіком користувачів SuperEx і привертайте до себе більше уваги.',
  8000101: 'Незалежно від того, чи ви новачок, чи досвідчений трейдер, наш Free Market принесе вам новий досвід та інвестиційні можливості. Негайно створюйте власні торгові пари, просувайте свої улюблені монети-меми і насолоджуйтеся комісійним доходом від торгових зборів!',
  8000102: 'Ваш загальний обсяг активів повинен перевищувати {resultData} USDT, перш ніж ви отримаєте право на створення торгової пари.',
  8000103: 'Лістинг улюбленого токена',
  8000104: 'Ви можете вибрати криптовалюту, якій ви віддаєте перевагу, і об\'єднати її з USDT, щоб створити унікальну торгову пару.',
  8000105: 'Отримуйте частину комісії',
  8000106: 'Коли обсяг торгів створеної вами торгової пари досягне певного порогового значення, частина комісійних за транзакції буде повернута вам у вигляді комісійної винагороди. Це дозволяє вам, як засновнику Торгівельної пари, також отримати частину прибутку від торгівлі.',
  8000107: 'Зараз ви є обмеженим користувачем і тимчасово не можете створювати нові торгові пари. Будь ласка, спробуйте ще раз завтра.',
  8000108: 'Будь ласка, виберіть мову',
  8000109: 'White Paper',
  8000110: 'Токен заборонено до лістингу!',
  8000111: 'Цей токен вже є в основному списку SuperEx Spot, ви не можете створити таку саму торгову пару!',
  8000112: 'Будь ласка, введіть дійсну адресу контракту / тікер!',
  8000113: 'Ваш баланс ET на основній дошці Spot недостатній. Для створення нового екземпляру торгової пари потрібно оплатити управлінську плату у розмірі {num} ET. Будь ласка, поповніть рахунок і спробуйте ще раз.',
  8000114: 'Ви зробили занадто багато неправильних введень під час створення нової торгової пари. Тому ви не можете подати більше запитів сьогодні. Будь ласка, спробуйте ще раз завтра.',
  8000115: 'Токен вже існує, тому зараз ми створимо для вас новий екземпляр торгової пари!',
  8000116: 'Будь ласка, підтвердіть наступну інформацію:',
  8000117: 'Десяткова довжина кількості токенів',
  8000118: 'Як вільно лістингувати монету',
  8000119: 'Повна назва токена',
  8000120: 'Десяткове значення ціни токена',
  8000121: 'Лістинг монет на SUPEREX: <em class="normal" style="color: #0CAA6D;">0 комісій за лістинг! </em><em class="normal" style="color: #1D90F5;">0 витрат на комунікацію! </em>1Завершіть лістинг на біржі за 1 хвилину та насолоджуйтесь прибутком до <em class="normal" style="color: #F65D62;">80%</em>',
  8000122: 'Вступ до токена англійською мовою',
  8000123: 'Необхідна наступна інформація:',
  8000124: 'Введене вами ім\'я екземпляра вже існує. Будь ласка, введіть інше ім\'я.',
  8000125: 'Наступна інформація є необов\'язковою:',
  8000126: 'Будь ласка, виберіть основний ланцюг або протокол, а також відповідну плату за управління.',
  8000127: 'Крок 1: Скопіюйте та вставте адресу контракту нової монети.',
  8000128: 'Будь ласка, введіть адресу контракту / тікер.',
  8000129: 'Підтвердити',
  8000130: 'Ваш екземпляр торгової пари {currency} успішно створено!',
  8000131: 'Крок 2: Якщо ця монета вперше виставляється на нашій біржі, вам потрібно заповнити кілька основних даних, таких як введення в монету та завантаження логотипу.',
  8000132: 'Ринки протоколу BTC',
  8000133: 'Крок 3: Вам потрібно лише назвати екземпляр цієї торгової пари, яку ви створили. Після цього процес лістингу завершується, і монету можна буде торгувати публічно.',
  8000134: 'Лістинг токенів',
  8000135: 'Будь ласка, введіть загальну пропозицію.',
  8000136: 'Крок 4: Як тільки щотижневий обсяг торгів вашого екземпляру досягне порогового значення, ви отримаєте частку з торгових комісій з цього екземпляру.',
  8000137: 'Якщо ви вибрали 2, це означає, що числове відображення ціни вашого токена буде з точністю до 0.01. Наприклад, ціна BTC відображається як $72156.78. Для большинства мем-коинов мы рекомендуем выбрать 11.',
  8000138: 'Будь ласка, введіть',
  8000139: 'Я збираюся почати лістинг монети',
  8000140: 'Будь ласка, введіть короткий опис токена англійською мовою.',
  8000141: 'Інстанс можна просто зрозуміти як різні версії однієї і тієї ж торгової пари, одна з яких — це створений вами інстанс. Інші користувачі відрізняють ці версії за іменами інстансів. Якщо користувачі виберуть ваш інстанс для торгівлі, у вас буде можливість отримати відповідну комісію за транзакції.',
  8000142: 'Формат електронної пошти неправильний.',
  8000143: 'Будь ласка, введіть адресу запиту до блокчейну.',
  8000144: 'Циркулюючий запас',
  8000145: 'Циркулюючий запас обмежений 1-20 цифрами у вигляді натурального числа.',
  8000146: 'Іконка токену',
  8000147: 'Підтримується формат PNG або JPG, розмір файлу не повинен перевищувати 5 МБ, ви можете завантажувати до 10 разів на день.',
  8000148: 'Дата випуску',
  8000149: 'Будь ласка, оберіть дату випуску.',
  8000150: 'Будь ласка, надайте посилання на White Paper.',
  8000151: 'Офіційний веб-сайт',
  8000152: 'Будь ласка, вкажіть посилання на офіційний веб-сайт.',
  8000153: 'Лістинг вільного ринку',
  8000154: 'Отримання лістингу вашого токена на Біржі',
  8000155: 'Введення назви токена обмежено 9 символами і підтримує лише цифри та літери.',
  8000156: 'Повна назва токена обмежена 30 символами, дозволені лише цифри, літери та пробіли.',
  8000157: 'Загальна пропозиція повинна бути натуральним числом від 1 до 20 цифр.',
  8000158: 'Поддерживаются английские заглавные и строчные буквы + цифры 1-9 + пробелы, первый или последний символ не может быть пробелом, и не допускаются подряд идущие пробелы.',
  8000159: '1. Емітент несе відповідальність за достовірність інформації, а платформа залишає за собою право в будь-який час видаляти токени або екземпляри торгових пар з лістингу, а також змінювати зміст інформації в будь-який час.',
  8000160: '2. Емітент зобов\'язаний провести ретельне дослідження токенів, що котируються, і нести відповідальність за їх обґрунтованість, відповідність і законність. Якщо платформа виявить будь-яку зловмисну, шкідливу або іншу специфічну поведінку чи вміст у смарт-контракті токена, вона безпосередньо делістингує токен і представлятиме користувачів у претензіях до емітента.',
  8000161: '3. Якщо емітент або будь-хто інший бажає внести зміни в інформацію про токен пізніше, вони повинні зв\'язатися з нашою службою підтримки клієнтів.',
  8000162: '4. Для захисту інтересів користувачів і усунення неякісних токенів, якщо екземпляр торгової пари, створений емітентом, не відповідає вимогам нашої платформи до торгової діяльності, емітент буде повідомлений про делістинг приблизно через тиждень. Щопонеділка платформа надсилатиме емітентам повідомлення про делістинг електронною поштою та через додаток для екземплярів, що не відповідають вимогам. Емітенти матимуть можливість подати заявку на продовження лістингу протягом 5 днів. Якщо заявка буде успішною, буде надано ще 4 тижні часу для спостереження; в іншому випадку емітенти будуть виключені з лістингу.',
  8000163: '5. Якщо копія торгової пари, створена емітентом токенів, відповідає порогу дивідендів платформи за обсягом торгів, вони отримають відповідні дивіденди з комісійних.',
  8000164: 'Ви готові надати певну кількість токенів для операційної діяльності та маркетингу, щоб розширити вплив монети?',
  8000165: '6. Емітент може зв\'язатися з нашою службою підтримки, щоб подати заявку на отримання статусу маркет-мейкера.',
  8000166: 'Створити',
  8000167: 'Ви збираєтеся створити екземпляр торгової пари {currency} і вирахувати {upFee} ET з вашого рахунку на основній спотовій платформі.',
  8000168: 'Ні',
  8000169: 'Так',
  8000170: 'Будь ласка, введіть свою електронну адресу, щоб наша команда з маркетингу могла з вами зв\'язатись',
  8000171: 'У вас є рекомендатель або контактна особа?',
  8000172: 'Будь ласка, введіть ім’я рекомендателя або контактну інформацію.',
  8000173: 'Натискаючи на цей прапорець, ви визнаєте всі пов’язані ризики і погоджуєтеся з нашими <a id="service_href" class="pointer" style="color: #D9A31A;text-decoration: underline" target="_self">Умовами та Положеннями</a>',
  8000174: 'Прибуток від лістингу',
  8000175: 'Право на лістинг на біржі',
  8000176: 'Цей токен зараз не підтримується для лістингу!',
  8000177: 'Заповніть інформацію',
  8000178: 'Іди поділись',
  8000179: 'на біржі!',
  8000180: 'SuperEx Free Market - криптосвіт користувачів, від користувачів, для користувачів',
  8000181: 'Я створив торгову пару {symbol} на SuperEx! На Місяць!',
}
export default uk



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/uk.js